import { useLanguages } from '~/service/language'

export enum ELayoutDirection {
  RTL = 'rtl',
  LTR = 'ltr'
}

export const useRTL = () => {
  const { isRTL, currentDirection } = useLanguages()
  
  return {
    isRTL,
    currentDirection: computed(() => 
      isRTL.value ? ELayoutDirection.RTL : ELayoutDirection.LTR
    ),
    ELayoutDirection
  }
}    